import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import styles from './index.module.scss';

const IconeBlackList = () => {
    return (
        <div className='position-relative'>
            <FontAwesomeIcon
                className="icone" 
                icon={'envelope'} 
            />
            <div className={styles['container-posicao-icone']}>
                <div className={styles['container-icone']}>
                    <FontAwesomeIcon 
                        icon={faTimes}
                        color='#e0eaec'
                    />
                </div>
            </div>
        </div>
    )
}

export default IconeBlackList;